import { render } from "./FlexRight.vue?vue&type=template&id=72850902&scoped=true"
import script from "./FlexRight.vue?vue&type=script&lang=js"
export * from "./FlexRight.vue?vue&type=script&lang=js"

import "./FlexRight.vue?vue&type=style&index=0&id=72850902&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72850902"]])

export default __exports__